var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFindProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.849,
    height: 100.075,
    viewBox: "0 0 94.849 100.075",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffde3e;}.b{fill:#fcd400;}.c{fill:#ffb427;}.d{fill:#d96b37;}.e{fill:#b14418;}.f{fill:#ff9d00;}.g{fill:#ff8b00;}.h{fill:#ff6900;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M138.074,154.668h23.313a1.054,1.054,0,0,0,1.07-.988,37.776,37.776,0,0,1,7.9-21.593,24.285,24.285,0,0,0,5.19-15c0-13.837-11.661-25.042-26.006-24.944-14.16.1-25.677,11.343-25.634,25.023a24.274,24.274,0,0,0,5.017,14.7A38.8,38.8,0,0,1,137,153.676,1.055,1.055,0,0,0,138.074,154.668Z",
    transform: "translate(-102.302 -74.132)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.855 18.01)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M245.617,92.141c-.773.005-1.537.046-2.293.116,13.083,1.218,23.312,11.869,23.312,24.828a24.285,24.285,0,0,1-5.19,15,37.774,37.774,0,0,0-7.9,21.593,1.054,1.054,0,0,1-1.07.988h4.987a1.054,1.054,0,0,0,1.07-.988,37.777,37.777,0,0,1,7.9-21.593,24.285,24.285,0,0,0,5.19-15C271.623,103.249,259.962,92.044,245.617,92.141Z",
    transform: "translate(-236.232 -92.141)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M225.49,268.1a1.742,1.742,0,0,0-1.747-.205l-3.175,1.388-3.273-1.394a1.76,1.76,0,0,0-1.48.054l-2.708,1.394-3.676-1.463a1.768,1.768,0,0,0-1.719.244,1.749,1.749,0,0,0-.656,1.6l0,.023,3.221,21.8h2.964l-2.983-20.187,2.381.948a1.465,1.465,0,0,0,1.213-.059l2.8-1.444L220,272.223a1.465,1.465,0,0,0,1.161-.005l1.788-.781-2.97,20.107h2.964l3.224-21.823A1.745,1.745,0,0,0,225.49,268.1Z",
    transform: "translate(-207.041 -233.421)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M447.318,238.064H438.14a1.466,1.466,0,0,1,0-2.932h9.178a1.466,1.466,0,1,1,0,2.932Z",
    transform: "translate(-353.935 -189.173)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M24.013,238.064H14.834a1.466,1.466,0,1,1,0-2.932h9.179a1.466,1.466,0,1,1,0,2.932Z",
    transform: "translate(-13.368 -189.173)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M389.515,377.613a1.461,1.461,0,0,1-1.037-.429l-6.49-6.49a1.466,1.466,0,0,1,2.073-2.073l6.49,6.49a1.466,1.466,0,0,1-1.037,2.5Z",
    transform: "translate(-309.592 -296.225)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M90.192,78.291a1.461,1.461,0,0,1-1.037-.429l-6.49-6.49A1.466,1.466,0,0,1,84.739,69.3l6.49,6.49a1.466,1.466,0,0,1-1.037,2.5Z",
    transform: "translate(-68.775 -55.408)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M383.024,78.29a1.466,1.466,0,0,1-1.037-2.5l6.49-6.49a1.466,1.466,0,0,1,2.073,2.073l-6.49,6.49A1.461,1.461,0,0,1,383.024,78.29Z",
    transform: "translate(-309.592 -55.407)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M83.7,377.613a1.466,1.466,0,0,1-1.037-2.5l6.49-6.49a1.466,1.466,0,0,1,2.073,2.073l-6.49,6.49A1.461,1.461,0,0,1,83.7,377.613Z",
    transform: "translate(-68.775 -296.225)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M249.966,12.11a1.466,1.466,0,0,1-1.466-1.466V1.466a1.466,1.466,0,1,1,2.932,0v9.178A1.466,1.466,0,0,1,249.966,12.11Z",
    transform: "translate(-202.541)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M233.059,385.624H219.9a.6.6,0,0,0-.595.595v4.959h14.347v-4.959A.6.6,0,0,0,233.059,385.624Z",
    transform: "translate(-179.054 -310.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M271.586,385.624h-4.392v5.554h4.987v-4.959A.6.6,0,0,0,271.586,385.624Z",
    transform: "translate(-217.581 -310.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M221.8,430.248h0a18.463,18.463,0,0,1-13.735,0h0a4.952,4.952,0,0,1-3.11-4.6V412.034h19.956v13.617A4.952,4.952,0,0,1,221.8,430.248Z",
    transform: "translate(-167.511 -331.498)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M250.735,412.034v13.617a4.952,4.952,0,0,1-3.11,4.6h0a18.445,18.445,0,0,1-4.374,1.153,18.463,18.463,0,0,0,9.361-1.153h0a4.952,4.952,0,0,0,3.11-4.6V412.034Z",
    transform: "translate(-198.317 -331.498)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.448 85.515)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 19.956,
    height: 2.545,
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M224.612,470.046h-19.35a1.267,1.267,0,0,0-.3.038v2.241c0,.077.005.153.009.23a1.272,1.272,0,0,0,.294.036h19.35a1.272,1.272,0,0,0,.294-.036c0-.076.009-.153.009-.23v-2.241A1.263,1.263,0,0,0,224.612,470.046Z",
    transform: "translate(-204.959 -463.686)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.407 85.515)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 4.987,
    height: 2.545,
    transform: "translate(0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M281.5,470.046v2.279c0,.089-.005.177-.01.265h4.694a1.272,1.272,0,0,0,.294-.036c0-.076.009-.153.009-.23v-2.241a1.269,1.269,0,0,0-.3-.038Z",
    transform: "translate(-281.491 -463.686)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindProduct);
export default __webpack_public_path__ + "static/media/find_product.bc6b9f1b05e0fbdcde0feae8b3677998.svg";
export { ForwardRef as ReactComponent };